import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { PAGE_CONTENT_HEADER_MAX_WIDTH } from "~/components/PageHeader/constants";
export const ContentHeaderDescriptionContainer = /*#__PURE__*/ memo((param)=>{
    let { className, style, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("min-w-[240px]", className),
        style: {
            maxWidth: PAGE_CONTENT_HEADER_MAX_WIDTH,
            ...style
        },
        ...props
    });
});
ContentHeaderDescriptionContainer.displayName = "ContentHeaderDescriptionContainer";
